"use client"

import { Button } from "@/components/ui/button";
import { Plus } from "geist-icons";
import Link from "next/link";

export default function ComingSoon() {
  return (
    <main>
      <section className="w-full min-h-screen bg-white dark:bg-black flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
        <div className="relative w-full max-w-[1100px] mt-12 sm:mt-16 md:mt-20 lg:mt-24">
          <div className="relative w-full h-[500px] sm:h-[550px] md:h-[600px] lg:h-[650px] border-dashed border-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto">

            {/* Content */}
            <div className="w-full h-full flex flex-col items-center justify-center gap-6 px-4">

              {/* Status badge */}
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#EAEAEA] dark:border-[#1E1E1E] bg-[#FAFAFA] dark:bg-[#0A0A0A]">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full  bg-[#0068D6] dark:bg-[#52A8FF]" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#0068D6] dark:bg-[#52A8FF]" />
                </span>
                <span className="text-xs text-[#666666] dark:text-[#878787] font-medium tracking-wide uppercase">
                  In Development
                </span>
              </div>

              {/* Heading */}
              <div className="flex flex-col items-center justify-center gap-2 text-center">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight text-[#0A0A0A] dark:text-white">
                  Coming Soon
                </h1>
                <p className="text-sm sm:text-base text-[#666666] dark:text-[#878787] max-w-sm leading-relaxed">
                  Something new is being built here. Check back soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}